import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { palette } from '../styles/branding'

const InterruptionContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 18px;
  padding: 6px;
  background: ${(props) => (props.backgroundColor === 'error' ? '' : '#FD0')};
  border: ${(props) => (props.border === 'error' ? ' 1px solid red' : '')};
`
const Label = styled.div`
  display: flex;
  align-items: center;
  background: ${(props) =>
    props.backgroundColor === 'error' ? 'red' : '#363d42'};
  color: ${palette.neutral1};
  padding: 6px 12px;
  font-weight: bold;
  font-size: 12px;
`
const MessageParagraph = styled.p`
  font-size: 14px;
  padding-left: 12px;
  color: ${(props) => props.color}
  margin: 0;
`

const Interruption = ({ text, variant, color }) => {
  const labelText = variant === 'error' ? 'Opgelet' : 'Storing'
  return (
    <InterruptionContainer border={variant} backgroundColor={variant}>
      <Label backgroundColor={variant}>{labelText}</Label>
      <MessageParagraph color={color}>{text}</MessageParagraph>
    </InterruptionContainer>
  )
}

Interruption.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
}

export default Interruption
